import makeStyles from '@mui/styles/makeStyles';

const styles = makeStyles(theme => ({
  confirmModalContainer: {
    position: 'absolute',
    top: '30%',
    left: '34%',
    backgroundColor: '#FFF',
    width: '32%',
    borderRadius: '12px'
  },

  confirmModalContent: {
    padding: '0 24px'
  },

  pointer: {
    cursor: 'pointer'
  },

  deleteWarningContainer: { 
    display: 'flex', 
    alignItems: 'center', 
    gap: '16px' 
  },

  header: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '24px 0 8px'
  },

  deleteIcon: {
    backgroundColor: '#FFDBDB', 
    display: 'flex', 
    padding: '6px', 
    borderRadius: '40px', 
    maxWidth: 'fit-content'
  },

  confirm: {
    color: '#232325',
    fontSize: '16px',
    fontFamily: `'Inter', sans-serif`,
    lineHeight: '24px'
  },

  warning: {
    marginBottom: '40px',
    marginTop: '8px',
    fontSize: '16px',
    lineHeight: '24px',
    fontFamily: `'Inter', sans-serif`,
    fontStyle: 'italic',
    color: '#F04438'
  },

  modalTitle: { 
    color: '#232325',
    fontWeight: 800,
    fontSize: '20px',
    lineHeight: '28px',
    fontFamily: `'Manrope', sans-serif`,
  },

  contactsButtonsContainer: {
    background: "#F7F7F9",
    display: 'flex', 
    justifyContent: 'flex-end',
    padding: '16px 24px',
    borderRadius: '0 0 12px 12px'
  },

  buttonClose: {
    background: "transparent",
    display: 'flex',
    color: "#232325", 
    fontSize: '16px',
    lineHeight: '24px',
    fontWeight: 700,
    justifyContent: 'center',
    alignItems: 'center'
  },

  buttonDelete: {
    display: 'flex',
    fontSize: '16px', 
    lineHeight: '24px',
    fontWeight: 700,
    justifyContent: 'center',
    alignItems: 'center'
  }
}))

export default styles
